import { Link } from 'react-router-dom';
import type { Video } from '@/mocks/videos';

interface VideoCardProps {
  video: Video;
  size?: 'normal' | 'large';
}

export default function VideoCard({ video, size = 'normal' }: VideoCardProps) {
  return (
    <Link
      to={`/article/${video.id}`}
      className="group block rounded-lg overflow-hidden bg-background-900 hover:bg-background-800/80 transition-all duration-300 cursor-pointer"
    >
      <div className={`relative overflow-hidden ${size === 'large' ? 'aspect-video' : 'aspect-video'}`}>
        <img
          src={video.thumbnail}
          alt={video.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
        <div className="absolute bottom-2 right-2 bg-black/70 text-foreground-200 text-xs px-2 py-0.5 rounded">
          {video.duration}
        </div>
        {video.hot && (
          <div className="absolute top-2 left-2 bg-primary-500 text-background-950 text-xs px-2 py-0.5 rounded font-medium">
            热门
          </div>
        )}
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90">
            <i className="ri-play-fill text-background-50 text-2xl"></i>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-foreground-100 text-sm font-medium line-clamp-2 mb-2 group-hover:text-primary-400 transition-colors">
          {video.title}
        </h3>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {video.views}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            {video.rating}
          </span>
        </div>
      </div>
    </Link>
  );
}